import type { BaseError } from '../models/BaseError'
import { useMapErrorMessage } from './useMapErrorMessage'

export function useErrorFormater (errors?: BaseError[], filterbyMeta: string[] = []): string[] {
  return (errors ?? [])
    ?.filter(error => (filterbyMeta.length === 0 ? true : filterbyMeta.some(key => error.meta?.[key] != null)))
    .map(error => useMapErrorMessage(error)?.filter(message => message.length > 0))
    .flatMap(e => e)
    .filter((v, i, a) => a.indexOf(v) === i)
}

export function useErrorFormaterByMeta (error: BaseError): BaseError[] {
  return Object.entries(error.meta ?? {}).map(([k, v]) => ({ code: error.code, meta: { [k]: v } }))
}
